export const DESIGN_FILTER_OPTIONS = [
  {
    label: 'All Designs',
    value: 'all',
    arrowOffset: 60
  },
  {
    label: 'Modsy Designs',
    value: 'modsy',
    arrowOffset: 34
  },
  {
    label: 'Self-Edited Designs',
    value: 'self',
    arrowOffset: 2
  }
];
